/* eslint-disable react/prop-types */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loading from "../Loading";
import NotFound from "../NotFound";

/**
 * Check if the JWT token is set
 */
export default function CheckAuthRP(route) {
  const { authenticationError, loading, user, role, authenticated } = useSelector(
    (state) => state.authentication
  );
  const navigate = useNavigate();

  useEffect(() => {
    const { redirect, authorized } = route;
    if (redirect) {
      if ((!authenticated || authenticationError) && authorized) {
        navigate(redirect());
      } else if (user) {
        if (!authorized) {
          navigate(redirect());
        }
      }
    }
  }, [authenticationError, user]);

  return loading ? (
    <Loading />
  ) : (
    <>
      <CheckAuthorized route={route} role={role} />
    </>
  );
}

export function CheckAuthorized({ route, role }) {
  if (route.roles && Array.isArray(route.roles)) {
    if (role && route.roles.includes(role)) {
      return route.component;
    }
    return NotFound;
  }
  return route.component;
}
